

const state = {
  url:'http://appdata.jscx666.cn', //正式环境
  //url: 'http://xhcapp.xhchat.cn', //测试环境
  app_version: "7.7.0",

  connect: false, //socket连接状态
  bll_login:false, //业务服务器登陆状态
  socket_login:false, //socket服务器登陆状态(在socket服务器记录socketid和 uid的对应关系)
  socket_id: '',
  uid: '',
  kill_info:'',
  warn_info: '',
  to_uid:'',

  topic_uid:'',
  rank_s1s2:{'s1':1, 's2':3},

  sysdic:'',
  const_data:'',

  objVal:{
    "match_rand":0, //随机匹配次数
    "match_diff":0, //异性匹配次数
    "uid":"",
    "setting":'',
    "theme_dark": false,
    "is_first_dark": true,
    "is_first_gift": false,
    "is_update_user_info": false,
    "update_kill":  "",
    "chat_score_promote": false,
    "msg_noread": -1,
    "is_set_sayHello": false,
    "wx_config":[],
    "festival_info": "", //节日活动
    "first_charge": [], //首充活动
    "voice_state": 0, //语音标识：0为空闲，1为正在录音，2为正在播放
    "voice_send_cointip": false, //发送语音付金币提示
    "voice_play_cointip":[]
  },

  http_cache: {
    index_rank1: { dtm: '', data_serve: []},
    index_rank2: { dtm: '', data_serve: []},
    popup_matching_avatar: { dtm: '', data_serve: []},
    my_sign: { is_sign: 99, sign_count: -1},

    // 豪气榜
    rank_score_1:{dtm:'', data_serve: []},
    rank_score_2:{dtm:'', data_serve: []},
    rank_score_3:{dtm:'', data_serve: []},
    rank_score_4:{dtm:'', data_serve: []},
    //魅力榜
    rank_coin_1:{dtm:'', data_serve: []},
    rank_coin_2:{dtm:'', data_serve: []},
    rank_coin_3:{dtm:'', data_serve: []},
    rank_coin_4:{dtm:'', data_serve: []},
    //我的好友
    my_friends: {dtm:'', data_serve: []},
    gift_wall: {dtm:'', data_serve: []},
    //打招呼
    say_hello: {dtm:'', data_serve: []},
    //邀好友统计
    invite_sum: {dtm:'', data_serve: {}}
  },

  //浏览网站的设备信息
  client: {
    is_mobile_browser: false,
    is_ios: false,
    is_andriod: false,
    is_wx: false,
    is_pc: false,
    browser: "", //浏览器
    os: "", //操作系统
    info: ""
  },

  //分站标识s
  fz_tag:sessionStorage.getItem('fz_tag') || '',

  //第三方登陆相关的（微信公众号登陆、....）
  openid:'',
  wxInfo:'',

  message: [],
  userinfo:[],

  index_tag:1,
  online_count:0,
  least_online:[],
  my_complain:[],
  complain_my:[],
  my_friend:[],
  msg_count:0,
  skipWxCheck: true, //跳过微信检查
  today_score: 20
};

export default state;
